/* * @Author: Wei Guojun * @Date: 2021-04-12 17:14:36 * @Last Modified by: Wei
Guojun * @Last Modified time: 2021-12-22 17:47:56 */
<template>
  <div class="pend">
    <el-form
      :inline="true"
      :model="searchMsg"
      class="demo-form-inline search"
      size="mini"
    >
      <el-form-item label="创建时间：">
        <el-date-picker
          style="width: 360px"
          v-model="searchMsg.date"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          align="right"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="limitPicker"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="运单号获取：">
        <el-select
          v-model="searchMsg.mail_get_type"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in maigetArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单来源：">
        <el-select
          v-model="searchMsg.order_source"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in comSource"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="快递类型：">
        <el-select
          v-model="searchMsg.express_type"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in expressArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单搜索：">
        <el-autocomplete
          style="width: 300px"
          :maxlength="20"
          popper-class="my-autocomplete"
          v-model.trim="searchMsg.key_word"
          :fetch-suggestions="querySearch"
          placeholder="收/寄件姓名、电话、运单号、标记码"
          @select="handleSelect"
        >
          <!-- <i
            class="el-icon-edit el-input__icon"
            slot="suffix"
            @click="handleIconClick"
          >
          </i> -->
          <template slot-scope="{ item }">
            <div class="name">{{ item }}</div>
            <!-- <span class="addr">{{ item.address }}</span> -->
          </template>
        </el-autocomplete>
      </el-form-item>
      <el-form-item label="订单创建人：" v-if="$store.state.teamModel=='2'">
        <el-select
          v-model="searchMsg.order_creator"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in createrArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>      
      <el-form-item label="订单状态：">
        <el-select
          v-model="searchMsg.order_status"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in maiorderArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="增值服务：">
        <el-select
          v-model="searchMsg.service_type"
          placeholder="请选择"
          class="selectBox"
        >
          <el-option
            v-for="item in addserve"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="table">
      <div class="topHeader">
        <div>
        共 <span class="total">{{ table_total }}</span >条订单
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-download"
            @click="appExport()"
            style="margin-left: 10px"
            plain
            >导出订单</el-button>
            <el-popover
              placement="bottom"
              width="140"
              trigger="click">
              <!-- <listDraggableVue ></listDraggableVue>             -->
              <ul>
                <li v-for="(item,index) in showrows" :key="index">
                  <el-checkbox v-model="item.show" @change="rowChange">{{item.label}}</el-checkbox>
                </li>    
              </ul>
              <el-button
                slot="reference"
                type="primary"
                size="mini"
                icon="el-icon-setting"
                style="margin-left: 10px"
                plain
              >显示字段设置</el-button>
            </el-popover>
        </div>
        <div>
          <el-button
            @click="search()"
            :loading="isSearch"
            type="primary"
            size="mini"
            icon="el-icon-search"
            >查询</el-button
          >
          <el-button @click="reset()" type="primary" plain icon="el-icon-refresh" size="mini"
            >重置</el-button
          >
        </div>
      </div>
      <el-table ref="table" size="mini" :height="tableHeight" v-loading="tableLoading"
      :header-cell-style="{ background: '#EBEEF5', color: '#333' }"
      border stripe fit highlight-current-row :data="tableData" id="tableBox" @sort-change="sortCreatTime">
        <el-table-column label="" align="center" width="50">
            <template slot="header">
              <el-checkbox @change="allCheck" v-model="all"></el-checkbox>
            </template>
            <template slot-scope="scope">
                <div @click="jgIsywyprint(scope.row)">
                <el-checkbox
                  :value="parcel_id_list.includes(scope.row.order_id)"
                  @change="checkBox(scope.row.order_id, scope.row)"
                  :disabled="scope.row.order_status == 1 || scope.row.morder_marking_infos.is_df == 1 || scope.row.morder_marking_infos.is_insured == 1 || scope.row.morder_marking_infos.is_cod == 1 || scope.row.morder_marking_infos.is_return == 1"></el-checkbox>
                </div>
            </template>
        </el-table-column>
        <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
        <el-table-column label="创建时间" align="left" width="96" sortable="custom" prop="create_time" v-if="showrows[0].show">
            <template slot-scope="scope">
               <span>{{ scope.row.create_time | formatDate }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="创建人" align="left" width="70" v-if="showrows[1].show">
            <template slot-scope="scope">
               <span>{{ scope.row.order_creator.name }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="订单号" prop="order_id" width="150" align="left" v-if="showrows[2].show"></el-table-column>
        <el-table-column label="运单号/标记码" align="center" width="160" v-if="showrows[3].show">
            <template slot-scope="scope">
               <div class="courier">
                <div class="copyCope">
                  {{ scope.row.mail_no }}
                  <i class="el-icon-copy-document sb_pointer"
                    v-if="scope.row.mail_no"
                    v-clipboard:copy="scope.row.mail_no"
                    v-clipboard:success="onCopy"
                  ></i>
                  <br />
                  <b v-if="scope.row.is_take_no == 2" style="color:red">{{
                    scope.row.takenoexcept.length > 3 ? "停发区" : scope.row.takenoexcept
                  }}</b>
                </div>
                <div v-if="scope.row.order_status == 1">已失效</div>
                <div v-if="scope.row.printer == 1">待快递员打印</div>
                <div v-if="scope.row.ticket_id">标记码:{{scope.row.ticket_id}}</div>
               </div>
            </template>
        </el-table-column>
        <el-table-column label="寄件信息" align="left" width="80" v-if="showrows[4].show">
            <template slot-scope="scope">
              <el-popover
                placement="top"
                width="200"
                trigger="hover">
                <div style="font-size:small">
                  <img  :src="scope.row.ys_send_Show ?openLook : closeLook" class="lookImg" @click="look_ys(scope.$index,'sender')"/>
                  <span v-if="!scope.row.ys_send_Show">
                    <span>{{ scope.row.sender_name | ysname }}</span>
                    <span class="paddL10">{{ scope.row.sender_phone | ysBill }}</span>
                  </span>
                  <span v-else>
                    <span>{{scope.row.sender_name}}</span>
                    <span class="paddL10">{{scope.row.sender_phone}}</span>
                  </span>
                  <br />
                  {{ scope.row.sender_province }} {{ scope.row.sender_city }}
                  {{ scope.row.sender_district }} {{ scope.row.sender_address }}
                </div>
                <span slot="reference" class="sb_pointer">{{scope.row.sender_name}}</span>
              </el-popover>
            </template>  
        </el-table-column>        
        <el-table-column label="收件信息" align="center" width="200" v-if="showrows[5].show">
            <template slot-scope="scope">
              <div style="text-align:left">
                <img :src="scope.row.ys_receive_Show ? openLook : closeLook" class="lookImg" @click="look_ys(scope.$index,'receiver')"/>
                  <span v-if="!scope.row.ys_receive_Show">
                    <span>{{ scope.row.receiver_name | ysname }}</span>
                    <span class="paddL10">{{ scope.row.receiver_phone | ysBill }}</span>
                  </span>
                  <span v-else>
                    <span>{{scope.row.receiver_name}}</span>
                    <span class="paddL10">{{scope.row.receiver_phone}}</span>
                  </span>
                <br />
                {{ scope.row.receiver_province }} {{ scope.row.receiver_city }}
                {{ scope.row.receiver_district }} {{ scope.row.receiver_address }}                 
              </div>
            </template>
        </el-table-column>
        <el-table-column label="物品类型" align="center" width="100" prop="item_type" v-if="showrows[6].show"></el-table-column>
        <el-table-column label="重量" align="center" width="80" v-if="showrows[7].show">
          <template slot-scope="scope">
              <span>{{ scope.row.goods_weight?scope.row.goods_weight+'KG':''}} </span>  
            </template>
        </el-table-column>
        <el-table-column label="快递类型" align="center" width="100" v-if="showrows[8].show">
            <template slot-scope="scope">
              <span>{{ scope.row | kdtype}}</span>  
            </template>
        </el-table-column>
        <el-table-column label="备注" align="center" v-if="showrows[9].show">
            <template slot-scope="scope">
               <span>{{ scope.row.item_note || "- -" }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="增值服务" align="left" width="210" v-if="showrows[10].show">
            <template slot-scope="scope">
               <div v-if="scope.row.morder_marking_infos.is_df == 1" >
                <el-tag size="mini" style="margin-right:10px">到付</el-tag>
               </div>
               <div v-if="scope.row.morder_marking_infos.is_sgj == 1" >
                <el-tag size="mini" style="margin-right:10px">水果件</el-tag>
               </div>
               <div v-if="scope.row.morder_marking_infos.is_insured == 1"><el-tag size="mini">保价</el-tag>
                物品价值{{scope.row.morder_marking_infos.insured_value}}元，保费{{scope.row.morder_marking_infos.insured_pay}}元
               </div>
               <div v-if="scope.row.morder_marking_infos.is_cod == 1"><el-tag size="mini">代收</el-tag>
                代收货款{{ scope.row.morder_marking_infos.cod_value}}元，服务费{{scope.row.morder_marking_infos.code_pay}}元
               </div>
               <div v-if="scope.row.morder_marking_infos.is_return == 1"><el-tag size="mini">签单</el-tag>
                返回单号:{{scope.row.morder_marking_infos.return_mail_no}}
                ,签单方式<span v-show ="scope.row.morder_marking_infos.return_value">{{scope.row.morder_marking_infos.return_value | returnValue}}</span>
               </div>
               <span v-if="(
                    scope.row.morder_marking_infos.is_df == 0 && 
                    scope.row.morder_marking_infos.is_sgj == 0 && 
                    scope.row.morder_marking_infos.is_insured == 0 && 
                    scope.row.morder_marking_infos.is_cod == 0 && 
                    scope.row.morder_marking_infos.is_return == 0
               )">--</span>
            </template>
        </el-table-column>
        <el-table-column label="物品来源" align="left" width="100" v-if="showrows[11].show">
          <template slot-scope="scope">
              <span>{{ scope.row.order_source | comeFrom }}</span>  
          </template>
        </el-table-column>   
        <el-table-column label="付款方式" align="left" width="80" v-if="showrows[12].show">
          <template slot-scope="scope">
              <span>{{ scope.row.morder_marking_infos.is_df == 1 ? '到付':'寄付' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="运费" align="left" width="70" v-if="showrows[13].show">
            <template slot-scope="scope">
               <span>{{ scope.row.daofu_amount ? scope.row.daofu_amount + " 元" : scope.row.daofu_amount }}</span>  
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="160" fixed="right">
          <template slot-scope="scope">
            <div class="operation_div" style=" display: flex;align-items: center;justify-content: space-around;"> 
              <div v-if="scope.row.order_status == 1" style="color:#909399">打印</div>
              <div @click="print(scope.row)" v-else>打印</div>
              <div v-if="zkRowlist.indexOf(scope.row.order_id) == -1" @click="toogleExpand(scope.row,'展开')">展开详情</div>
              <div v-else @click="toogleExpand(scope.row,'收起')">收起详情</div>
              <el-dropdown size="small"  @command="(command)=>{handleCommand(command,scope.row)}">
                <span class="el-dropdown-link" style="font-size:12px">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if="!scope.row.mail_no && !(
                    scope.row.morder_marking_infos.is_df == 1 || 
                    scope.row.morder_marking_infos.is_insured == 1 ||   
                    scope.row.morder_marking_infos.is_cod == 1 || 
                    scope.row.morder_marking_infos.is_return == 1
                  ) && scope.row.order_status == 0" @click="getmailNo(scope.row)" command="e">获取运单号</el-dropdown-item>
                  <el-dropdown-item v-if="!scope.row.mail_no && !(
                    scope.row.morder_marking_infos.is_df == 1 || 
                    scope.row.morder_marking_infos.is_insured == 1 ||   
                    scope.row.morder_marking_infos.is_cod == 1 || 
                    scope.row.morder_marking_infos.is_return == 1
                  )" @click="editBill(scope.row)" command="a">修改订单</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.order_status != 1" @click="cancelBill(scope.row.order_id)" command="b">取消订单</el-dropdown-item>
                  <el-dropdown-item @click="delBill(scope.row)" command="c">删除订单</el-dropdown-item>
                  <el-dropdown-item  @click="oneceNew(scope.row)" command="d">再建一单</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="expand" width="1" align="center">
          <template slot-scope="props">
            <div class="info">
              <el-row>
                <el-col :span="6">
                  <div class="grid-content">
                    <span>订单号：</span>
                    <span>{{ props.row.order_id }}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <span>订单来源：</span>
                    <span>{{props.row.order_source | comeFrom}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <span>付款方式：</span>
                    <span>{{props.row.morder_marking_infos.is_df == 1 ? '到付':'寄付'}}</span>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <span>运费：</span>
                    <span>{{ props.row.daofu_amount ? props.row.daofu_amount + " 元" : '--'}}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6"  v-if="props.row.morder_marking_infos.is_insured == 1">
                  <div class="grid-content">
                    <span>保价服务：</span>
                    <span>物品价值{{props.row.morder_marking_infos.insured_value}}元，保费{{props.row.morder_marking_infos.insured_pay}}元</span>
                  </div>
                </el-col>
                <el-col :span="6" v-if="props.row.morder_marking_infos.is_cod == 1">
                  <div class="grid-content">
                    <span>代收货款：</span>
                    <span>{{ props.row.morder_marking_infos.cod_value}}元，服务费{{props.row.morder_marking_infos.code_pay}}元</span>
                  </div>
                </el-col>
                <el-col :span="6" v-if="props.row.morder_marking_infos.is_return == 1">
                  <div class="grid-content">
                    <span>签单返回：</span>
                    <span>{{ props.row.morder_marking_infos.return_value | returnValue}},返回单号:{{props.row.morder_marking_infos.return_mail_no}}</span>
                  </div>
                </el-col>
                <!-- <el-col :span="3">
                  <div class="grid-content">
                    <span>智橙网：</span>
                    <span>{{props.row.express_type == 'TK' ? '有':'无'}}</span>
                  </div>
                </el-col> -->
              </el-row>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pages">
      <div class="pages_left"></div>
      <div class="pages_right">
        <el-pagination
          :current-page.sync="currPage"
          :page-size="page_size"
          @size-change="changeSizes"
          :page-sizes="[30, 50, 100, 200, 500]"
          @current-change="currentPage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="table_total"
        ></el-pagination>
        <div slot="append" class="sure" type="primary">确定</div>
      </div>
    </div>
    <footer>
      <div class="footer">
        <div>
          <div class="allCheck">
            <span
              >已选<b>{{ parcel_id_list.length }}</b></span
            >
          </div>
          <div class="btn">
            <el-button type="primary" class="footBtn" icon="el-icon-delete" plain  @click.prevent="delAll"
              >批量删除</el-button
            >
            <el-button type="primary" class="footBtn" icon="el-icon-plus" plain @click.prevent="submitKdy"
              >批量快递员打印</el-button
            >
            <el-button
              type="primary"
              class="footBtn"
              icon="el-icon-printer"
              @click.prevent="allPrint"
              :loading="allPrintLoading"
              >批量打印</el-button
            >
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import print from "@/api/print";
import util from "@/util/util";
import { PrintWaiting, startPrinting } from '@/util/ptintTool.js';
import myLocalStorage from "@/util/crypto.js";
import  myMinix  from '@/mixin/minix';
import  teamMix  from '@/mixin/teamMix';
import request from "@/util/request";
import { mapGetters } from "vuex";
// import listDraggableVue from '../../components/listDraggable.vue';
const rowshowArr = [
  {label:'创建时间',show:true},
  {label:'创建人',show:true},
  {label:'订单号',show:false},
  {label:'运单号/标记码',show:true},
  {label:'寄件信息',show:true},
  {label:'收件信息',show:true},
  {label:'物品类型',show:true},
  {label:'重量',show:true},
  {label:'快递类型',show:true},
  {label:'备注',show:true},
  {label:'增值服务',show:false},
  {label:'订单来源',show:false},
  {label:'付款方式',show:false},
  {label:'运费',show:false},
]
let limitTime = null
export default {
  mixins: [myMinix,teamMix],
  name: "waitPrinted",
  data() {
    return {
      tableHeight:300,
      searchMsg: {
        order_creator:0,
        // printer: 0, // 打印人
        date: [util.getlimiTime(30) +' 00:00:00', util.getlimiTime(0)+' 23:59:59'],
        sort: 4,
        mail_get_type: 0,
        order_status: 0, //0 正常 1 已取消 2已删除
        order_source: 0,
        key_word: "", //搜索框
        service_type: "",
        express_type:'',
      },
      maigetArr: [
        { label: "全部", value: 0 },
        { label: "已获取", value: 1 },
        { label: "未获取", value: 2 },
        // {label:'已取消',value:3},
      ],
      maiorderArr: [
        { label: "未取消", value: 0 },
        { label: "已取消", value: 1 },
      ],
      all: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const start = new Date(util.getlimiTime(0) + ' 00:00:00');
              const end = new Date(util.getlimiTime(0) + ' 23:59:59');
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date(util.getlimiTime(0) + ' 23:59:59');
              const start = new Date(util.getlimiTime(0) + ' 00:00:00');
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date(util.getlimiTime(0) + ' 23:59:59');
              const start = new Date(util.getlimiTime(0) + ' 00:00:00');
              const nows = start.getDay() || 7;
              start.setTime(start.getTime() - 3600 * 1000 * 24 * (nows - 1));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const end = new Date(util.getlimiTime(0) + ' 23:59:59');
              const start = new Date(util.getlimiTime(0) + ' 00:00:00');
              start.setDate(1);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
        disabledDate: (time) => {
          let nowDate = new Date();
          let oneDay = 1000 * 60 * 60 * 24;
          let current_time =  util.getlimiTime(0) + ' 23:59:59'
          let oneMonthLater = new Date(nowDate.getTime() - oneDay * limitTime);
          return time.getTime() > new Date(current_time).getTime() || time.getTime() < oneMonthLater;
        },
      },
      currPage: 1, //当前页数
      tableData: [], // 数据
      table_index: [], //展开
      table_total: 0, //总数
      page_size: 30,
      isSearch: false, //搜索中...
      keyWord: [], //输入框前选项
      forSearch: false, //是否是搜索
      parcel_id: "", //包裹id
      parcel_id_list: [],
      isLoading: false,
      haveData: true,
      dialog: false,
      tableLoading: false,
      allPrintLoading: false,
      first_click: true,
      cooldown: 0,
      Isdesktop: "",
      historyRecord: [],
      waitprint_orderid:[],
      zkRowlist:[],
      showrows:rowshowArr,
    };
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return util.formatTime(date, "yyyy-MM-dd hh:mm:ss");
    },
    kdtype(row){
      if(row.express_type == 'TK'){
        return '智橙网'
      }else{
        if(row.morder_marking_infos){
           if(row.morder_marking_infos.is_sgj == 1){
             return '水果件'
           }else{
             return '普通快递'
           }    
        }else{
          return '普通快递'
        }
      }     
    },
    comeFrom(data) {
      var string = "";
      let map = {101:'寄快递创建',102:'电脑导入',103:'邀请下单',104:'代客下单'}
      string = map[data] || ''  
      return string;
    },
  },
  components: {
    // listDraggableVue
    //组件声明
    // gotoTop,
  },
  computed: {
    ...mapGetters(["getListrefresh"]),
  },
  watch: {
    getListrefresh: {
      handler(val) {
        if (val) {
          this.loadData();
        }
      },
    },
  },
  destroyed() {},
  created() {
    localStorage.getItem("historyWaitRecord") &&
      (this.historyRecord = JSON.parse(
        localStorage.getItem("historyWaitRecord")
      ));
  },
  mounted: function () {
    limitTime = util.getJsonValues(this.$store.state.commondict,'wait_print_limited') || 40;
    //数据挂载
    const Isdesktop = util.getCookie("from"); //是不是桌面
    if (Isdesktop) {
      this.Isdesktop = Isdesktop;
    }
    let waitPrintRow = util.getCookie('waitPrintRow');
    if(waitPrintRow){
      this.showrows = JSON.parse(waitPrintRow)
    }
    let userset = JSON.parse(this.$store.state.userSet);
    this.searchMsg.sort = Number(userset.waitSort) || 4;
    this.loadData();
    util.getTableHeight(this,document.getElementById('tableBox'),84) ;
    window.addEventListener('resize',()=>{
      util.getTableHeight(this,document.getElementById('tableBox'),84);     
    });
    window.addEventListener("keydown", this.handkeyCode, true);
  },
  beforeDestroy(){
    window.removeEventListener('resize',()=>{
      util.getTableHeight(this,document.getElementById('tableBox'),84);  
    }) 
  },
  methods: {
    rowChange(){
      util.setCookie('waitPrintRow',JSON.stringify(this.showrows))
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
    handleCommand(a,b){
      let row = b;
      if(a== 'a'){
        this.editBill(row) 
      }else if(a== 'b'){
        this.cancelBill(row.order_id)
      }else if(a== 'c'){
        this.delBill(row)
      }else if(a=='d'){
        this.oneceNew(row)
      }else{
        this.getmailNo(row)
      }
    },
    //获取运单号
    getmailNo(row){
      print.getmaiNo(row.order_id).then(res=>{
        if(res.success){
          this.$message({ type: "success", message: "运单号获取成功!" });
          this.loadData();
        }
      })
    },
    sortCreatTime(object){
      if(object.order == 'descending'){
        this.searchMsg.sort = 3
      }else{
        this.searchMsg.sort = 4
      }
      let userset = JSON.parse(this.$store.state.userSet);
      userset.waitSort = this.searchMsg.sort;
      this.$store.commit("SET_USER_SET", JSON.stringify(userset));
      this.loadData();
    }, 
    toogleExpand(row, text) {
      let $table = this.$refs.table;
      if (text == "展开") {
        this.tableData.map((item) => {
          if (row.order_id != item.order_id) {
            $table.toggleRowExpansion(item, false)
          }
        })
        this.currentIndex = row.order_id
        this.zkRowlist.push(row.order_id)
      } else {
        this.currentIndex = null;
        let getLocation = this.zkRowlist.indexOf(row.order_id);
        this.zkRowlist.splice(getLocation, 1); 
      }
      $table.toggleRowExpansion(row)
    },
    look_ys(index,type){
      let list = this.tableData
      if(type == 'sender'){
        list[index].ys_send_Show = !list[index].ys_send_Show
      }else{
        list[index].ys_receive_Show = !list[index].ys_receive_Show
      }
      this.tableData = list
    },    
    
    jgIsywyprint(row) {
      if (row.morder_marking_infos.is_df == 1) {
        this.$message.warning("到付单仅支持快递员打印，请快递员到韵镖侠-协议订单查看本订单");
        return false     
      } else if(row.morder_marking_infos.is_insured == 1 || row.morder_marking_infos.is_cod == 1 || row.morder_marking_infos.is_return == 1){
        this.$message.warning("保价、代收货款、签单返回单仅支持快递员打印，请快递员到韵镖侠-协议订单查看本订单");   
        return false 
      } else {
        return true;
      }
    },
    querySearch(queryString, cb) {
      var restaurants = this.historyRecord;
      cb(restaurants);
    },
    handleSelect(item) {
      this.searchMsg.key_word = item;
      console.log(item);
    },
    // handleIconClick(ev) {
    //   console.log(ev);
    // },
    appExport() {
      let nowTime = new Date().getTime() - this.cooldown;
      if (!this.cooldown || nowTime > 2000) {
        const jgsort = util.jgsort(this.searchMsg.sort);
        this.cooldown = new Date().getTime();
        const link = document.createElement("a");
        let start_time = '';
        let end_time = '';
        if (this.searchMsg.date == null) {
          this.$message.error('请选择导出时间区间')
          return
        }
        if (this.searchMsg.date[0] && this.searchMsg.date[1]) {
          start_time = this.searchMsg.date[0] || ''
          end_time = this.searchMsg.date[1] || ''
        }
        link.href = (
          window.location.origin +
          "/file/downloadOrdersGet?" +
          "accountId=" +
          util.getCookie("account_id") +
          "&keyWord=" +
          this.searchMsg.key_word +
          "&orderType=0" +
          "&orderSource=" +
          this.searchMsg.order_source +
          "&orderStatus=" +
          this.searchMsg.order_status +
          "&sort=" +
          jgsort[1] +
          "&orderByColumn=" +
          jgsort[0] +
          "&serviceType=" +
          this.searchMsg.service_type +
          "&mailGetType=" +
          this.searchMsg.mail_get_type +
          "&expressType=" + this.searchMsg.express_type +
          "&mailOrderStatus=&startTime=" +
          start_time +
          "&endTime=" +
          end_time +
          "&websocketToken=" +
          util.getCookie("websocket_token")
        ).replace(/\s+/g, "%20");
        document.body.appendChild(link);
        link.click(); //点击下载
        document.body.removeChild(link); //下载完成移除元素
      } else {
        this.$message.warning("按钮点击过快！");
      }
    },
    editBill(item) {
      console.log(item,'lalla');
      this.$store.commit("SET_EDIT_BILL", JSON.stringify(item));
      this.$store.commit("SET_ROUTE_FROM", "/editBill");
      this.$router.push({ path: "/editBill" });
    },
    showDate(val) {
      const search = this.searchMsg.key_word;
      if (val.indexOf(search) !== -1 && search !== "") {
        return val.replace(
          search,
          '<b style="color:#F56C6C">' + search + "</b>"
        );
      } else {
        return val;
      }
    },
    handkeyCode(e) {
      let key = null;
      if (window.event === undefined) {
        key = e.keyCode;
      } else {
        key = window.event.keyCode;
      }
      if (key === 13) {
        this.search();
      }
    },
    //导出
    exportRecord() {
      if (this.tableData.length <= 0) {
        this.$message({
          message: "您要导出的数据为空，请查询后再试！",
          type: "warning",
        });
        return;
      }
      print.downloadFile(this, 0).then((res) => {
        console.log(res);
      });
    },

    /** 一键复制 */
    onCopy(e) {
      this.$message({
        message: "快递单号: " + e.text + " 复制成功",
        type: "success",
      });
    },
    /**取消订单 */
    cancelBill(orderId) {
      this.$confirm(
        "确定取消所选的订单吗?<br/>取消后可在订单状态中选择【已取消】查看取消的订单，已获取的运单号若无揽件数据将于40天后自动回收",
        "提示",
        {
          confirmButtonText: "确定取消订单",
          cancelButtonText: "再考虑下",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          print.cancelData(this, orderId).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "订单取消成功!" });
              this.loadData();
              this.$store.dispatch("getthreeNum");
            }
          });
        })
        .catch(() => {});
    },
    /** 批量取消 */
    cancelAll() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要取消的订单",
        });
        return;
      }
      this.$confirm(
        "确定取消所选的订单吗?<br/>取消后订单和运单号都将失效，不支持打印和提交给快递员,可在订单状态中选择【已取消】查看取消的订单，已获取的运单号若无揽件数据将于40天后自动回收",
        "提示",
        {
          confirmButtonText: "确定取消订单",
          cancelButtonText: "再考虑下",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          print.batchcancel(this, this.parcel_id_list).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "订单取消成功!" });
              this.loadData();
            }
          });
        })
        .catch(() => {});
    },
    /**删除订单 */
    delBill(item) {
      let content = "";
      if (item.mail_no) {
        content =
          "订单已获取运单号，是否确认删除?删除后已获取的运单号不会提前回收，若无揽件数据将于40天后自动回收。";
      } else {
        content = "确认删除所选订单吗？";
      }
      this.$confirm(content, "提示", {
        confirmButtonText: "确定删除",
        cancelButtonText: "再考虑下",
        dangerouslyUseHTMLString: true,
        type: "warning",
      })
        .then(() => {
          print.delData(this, item.order_id).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "订单删除成功!" });
              this.loadData();
              this.$store.dispatch("getthreeNum");
            }
          });
        })
        .catch(() => {});
    },
    /** 批量删除 */
    delAll() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要删除的订单",
        });
        return;
      }
      let has_mail_no = this.tableData.filter((v) => {
        return v.mail_no && this.parcel_id_list.includes(v.order_id);
      });
      // debugger;
      this.$confirm(
        "已选中" +
          this.parcel_id_list.length +
          "单，其中" +
          has_mail_no.length +
          "单已获取运单号,是否确定删除?<br/>删除后已获取的运单号不会提前回收，若无揽件数据将于40天后自动回收。",
        "提示",
        {
          confirmButtonText: "确定删除",
          cancelButtonText: "再考虑下",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
        .then(() => {
          print.batchdel(this, this.parcel_id_list).then((res) => {
            if (res.success) {
              this.$message({ type: "success", message: "订单删除成功!" });
              this.loadData();
              this.$store.dispatch("getthreeNum");
            }
          });
        })
        .catch(() => {});
    },
    /** 批量提交快递员 */
    submitKdy() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要提交给快递员的订单",
        });
        return;
      }
      if (this.$store.state.bindKdy == 10) {
        this.$message.warning(
          '您当前未与快递员建立协议关系，无法提交快递员打印'
        )
        return
      }
      this.faceLesswarn(()=>{this.submitKdyActions()})
    },
    submitKdyActions(){
      this.$confirm(
        '确定将所选订单提交给协议快递员吗?<br/>提交后订单只能由业务员打印,本人若想打印可在"已打印"中重新打印',
        "提示",
        {
          confirmButtonText: "确定提交",
          cancelButtonText: "我再想想",
          dangerouslyUseHTMLString: true,
          type: "warning",
        }
      )
      .then(() => {
        if (this.first_click) {
          this.first_click = false;
          print.sumbKdy(this, this.parcel_id_list).then((res) => {
            if (res.success) {
              this.first_click = true;
              if (res.data > 0) {
                this.$message.warning(
                  "批量提交快递员存在" + res.data + "单提交失败,请排查后重试"
                );
              } else {
                this.$message({
                  type: "success",
                  message: "订单提交快递员成功!",
                });
              }
              this.loadData();
              this.$store.dispatch("getthreeNum");
            } else if (
              ~~res.data.code == 7010 ||
              ~~res.data.code == 7013 ||
              ~~res.data.code === 7011 ||
              ~~res.data.code === 7012 ||
              ~~res.data.code === 7018 ||
              ~~res.data.code === 7019
            ) {
              this.first_click = true;
              this.loadData();
            } else {
              this.first_click = true;
            }
          });
        } else {
          this.$message.warning("单击次数过快，请稍后再试");
        }
      })
      .catch(() => {
        this.first_click = true;
      });
    },
    /** 加载更多 */
    loadData() {
      this.tableLoading = true;
      let self = this;
      self.parcel_id_list = [];
      this.all = false;
      print.waiting(this).then((res) => {
        if (res.success) {
          self.tableLoading = false;
          self.table_total = res.data.total;
          self.$store.state.waitNum = res.data.total;
          let datas = res.data.list
          datas.forEach((value, key) => {
            value.ys_send_Show = false
            value.ys_receive_Show = false
          });
          self.tableData = datas;
          if (res.data.list.length > 0) {
            this.haveData = true;
          } else {
            this.haveData = false;
          }
          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })
        }
      });
    },
    //时间选择器限制
    limitPicker(){
      if(this.searchMsg.date == null){return}
      const start = new Date(this.searchMsg.date[0]).getTime()
      const end = new Date(this.searchMsg.date[1]).getTime()
      if(end - start > 2.6784e9){
        this.$message.error("起始时间与结束时间跨度不可大于31天~");
      }
    },
    /** 搜索 */
    search() {
      const start = new Date(this.searchMsg.date[0]).getTime()
      const end = new Date(this.searchMsg.date[1]).getTime()
      if(end - start > 2.6784e9){
        this.$message.error("起始时间与结束时间跨度不可大于31天~");
        return;
      }
      this.all = false;
      this.forSearch = true;
      this.isSearch = true;
      this.forSearch = true;
      this.currPage = 1;
      this.table_index = [];
      //历史记录
      if (this.searchMsg.key_word != "") {
        if (this.historyRecord.length >= 5) {
          this.historyRecord.splice(4, 1);
        }
        !this.historyRecord.includes(this.searchMsg.key_word) &&
          this.historyRecord.unshift(this.searchMsg.key_word);
        localStorage.setItem(
          "historyWaitRecord",
          JSON.stringify(this.historyRecord)
        );
      }

      this.loadData();
      setTimeout(() => {
        this.isSearch = false;
      }, 500);
    },
    /** 重置 */
    reset() {
      this.searchMsg = {
        printer: 0, // 打印人
        date: [util.getlimiTime(30) +' 00:00:00', util.getlimiTime(0)+' 23:59:59'],
        key_word: "", //搜索框
        mail_get_type: 0,
        order_status: 0,
        order_source: 0,
        sort: 4,
        service_type: "",
        express_type:'',
      };
      this.select = "";
      this.currPage = 1;
      this.forSearch = false;
      this.table_index = [];
      this.loadData();
    },
    /** 改变条数 */
    changeSizes(e) {
      this.page_size = e;
      this.currPage = 1;
      if (this.forSearch) {
        this.search();
      } else {
        this.loadData();
      }
    },
    /** 当前页 */
    currentPage(e) {
      this.currPage = e;
      if (this.forSearch) {
        this.search();
      } else {
        this.loadData();
      }
    },
    /** 单选单个Box */
    checkBox(e, t) {
      let list = this.parcel_id_list;
      if (list.indexOf(e) != -1) {
        list.splice(
          list.findIndex((item) => item === e),
          1
        );
      } else {
        list.push(e);
      }
      if (list.length > 0 && list.length < this.tableData.length) {
        this.all = false;
      } else if (list.length == this.tableData.length) {
        this.all = true;
      } else {
        this.all = false;
      }
      this.parcel_id_list = list;
    },
    /** 全选 */
    allCheck(e) {
      let list = [];
      if (e) {
        this.tableData.forEach((item) => {
          if (item.order_status == 0  && !(
            item.morder_marking_infos.is_df == 1 || 
            item.morder_marking_infos.is_insured == 1 ||
            item.morder_marking_infos.is_cod == 1 ||
            item.morder_marking_infos.is_return == 1)){
            list = [...list, item.order_id];
          }
        });
        this.all = true;
      } else {
        this.all = false;
      }
      this.parcel_id_list = list;
    },
    /** 批量打印 */
    allPrint() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要打印的订单",
        });
        return;
      }
      const {lodopStatus,WebSocketstatus,name} = this.$store.state.connetStatus
      if(!lodopStatus || !WebSocketstatus || !name){
        this.$printError(true);
        return
      }
      this.faceLesswarn(()=>{this.allPrintActions()})   
    },
    allPrintActions(){
      this.$confirm(
        "已选<span style='color:#ff0000'>" +
          this.parcel_id_list.length +
          "</span>个订单，确认打印已选订单？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
      .then(() => {
        this.allPrint_next();
      })
      .catch(() => {
        this.allPrintLoading = false;
        this.first_click = true;
      });
    },
    //批量打印的白马分包处理
    allPrint_next(){
      this.allPrintLoading = true;
      if (this.first_click) {
        this.first_click = false;
        let queryQarcelId = util.arrayGroup(this.parcel_id_list, 50);  //前端50一组分包提交
        this.waitprint_orderid = [];
        let busParams = queryQarcelId.map((el=>{
        return{
          action:'kdyserver.print.prePrintOrder',
          data:{
            account_id: util.getCookie("account_id"),
            order_ids: el,
            template_platform:"lodop"
          }
        }
      }))
      request.post(this,{
        action:'kdyserver.account.homeBus',
        data:{ 
          'noasync':1,
          'parameters':request.getBusparameters(busParams)
        }
        }).then(res=>{
          if(res.success){
            let len = busParams.length
            //错误提示处理
            let filerror = res.body.data.filter( el=>{ return el.code!=200 })   //过滤非200请求
            if(filerror.length){   //去重
              const norepeat_filerror = util.delRepeatJson(filerror,'code')
              for(let j = 0;j < norepeat_filerror.length;j++){
                this.$message.error(norepeat_filerror[j].message || norepeat_filerror[j].remark);
              }
            }
            for(let i = 0 ; i < len; i ++){
              this.waitprint_orderid = [...this.waitprint_orderid,...res.body.data[i].data]
              if(len == i+1){
                this.allPrint_last()
              }
            }
          } 
        })  
      } else {
        this.$message.warning("单击次数过快，请稍后再试");
      }
    },
    //批量打印的异步处理
    allPrint_last(){
      if(this.waitprint_orderid.length){
        const num = this.parcel_id_list.length - this.waitprint_orderid.length
        if(num > 0){
          util.gj_message("打印信息已成功提交至"+util.getCookie("defult_print")+"打印,批量打印中存在" + num + "单取号失败无法打印",2000);
        }else{
          util.gj_message("打印信息已成功提交至"+util.getCookie("defult_print")+"打印,若打印机长时间不出纸，可以F5刷新浏览器后再次操作",2000);              
        }
        PrintWaiting(this).then(res=>{
          if (res.initPrint) {
            const pagenum = util.getJsonValues(this.$store.state.commondict,'packsize') - 0 || 10
            var groupedArray = util.arrayGroup(this.waitprint_orderid, pagenum);
            let busParams = groupedArray.map((el=>{
              return{
                action:'kdyserver.print.printOrder',
                data:{
                  account_id: util.getCookie("account_id"),
                  order_ids: el,
                  template_platform:"lodop"
                }
              }
            }))
            request.post(this,{
              action:'kdyserver.account.homeBus',
              data:{
                'parameters':request.getBusparameters(busParams)
              }
              }).then(res=>{
                if(res.success){
                  let len = busParams.length
                  for(let i = 0 ; i < len; i ++){
                    startPrinting(res.body.data[i].data)
                    if(len == i+1){
                      this.parcel_id_list = [];
                      this.all = false;
                      this.first_click = true;
                      this.allPrintLoading = false;
                      this.loadData();
                    }
                  }
                } 
              })    
          }
        })         
      }else{
        this.parcel_id_list = [];
        this.all = false;
        this.allPrintLoading = false;
        this.loadData();
        this.first_click = true;
      }
    },
    /** 单个打印 */
    print(item) {
      if(!this.jgIsywyprint(item)){
       return   
      }     
      const {lodopStatus,WebSocketstatus,name} = this.$store.state.connetStatus
      if(!lodopStatus || !WebSocketstatus || !name){
        this.$printError(true);
        return
      }
      this.faceLesswarn(()=>{this.printActions(item)})
    },
    printActions(item){
      this.isLoading = true;
      if(this.first_click){
        this.first_click = false;
        print.prePrintData(this, [item.order_id]).then((res) => {
          if (res.success) {
            util.gj_message(
              "打印信息已成功提交至" +
                util.getCookie("defult_print") +
                "打印,若打印机长时间不出纸，可以F5刷新浏览器后再次操作",2000
            );
            const result = res.data;
            PrintWaiting(this).then(res=>{
              if (res.initPrint) {
                const pagenum = util.getJsonValues(this.$store.state.commondict,'packsize') - 0 || 10
                var groupedArray = util.arrayGroup(result, pagenum);
                for(let i = 0;i< groupedArray.length;i++){
                  print.printData(this,groupedArray[i]).then(res=>{
                    if(res.success){
                      startPrinting(res.data).then(()=>{this.loadData();this.$store.dispatch("getthreeNum");})
                    }
                  })                
                }   
              }
            })
            
            this.first_click = true;
          }else{
            this.first_click = true;
          }
        });
      }else{
        this.$message.warning("单击次数过快，请稍后再试");
      }
    },
    /** 再建一单 */
    oneceNew(data) {
      console.log("item", data);
      const send = {
        name: data.sender_name, // 姓名
        phone: data.sender_phone, // 手机号
        province: data.sender_province, // 省
        province_code: data.sender_province_code, //省编码
        city: data.sender_city, // 市
        city_code: data.sender_city_code, //市编码
        area_code: data.sender_district_code, //区编码
        area: data.sender_district, //区列表
        address: data.sender_address, // 详细地址
        pca: [
          data.sender_province_code,
          data.sender_city_code,
          data.sender_district_code,
        ],
      };
      const collect = {
        name: data.receiver_name, // 姓名
        phone: data.receiver_phone, // 手机号
        province: data.receiver_province, // 省
        province_code: data.receiver_province_code, //省编码
        city: data.receiver_city, // 市
        city_code: data.receiver_city_code, //市编码
        area_code: data.receiver_district_code, //区编码
        area: data.receiver_district, //区列表
        address: data.receiver_address, // 详细地址
        pca: [
          data.receiver_province_code,
          data.receiver_city_code,
          data.receiver_district_code,
        ],
      };
      if (data.order_source == 101 || data.order_source == 102) {
        const preSave = {
          ruleForm: { send, collect },
          typeContent: util.stringthingType(data.item_type),
          textarea: data.item_note,
          Added_Collect: [],
          daofu_amount: data.daofu_amount,
          service_type: data.service_type,
          express_type: data.express_type,
          pri:data.pri,
          morder_marking_infos:data.morder_marking_infos,
          onceNews:true,
        };
        myLocalStorage.setItem("preSave", JSON.stringify(preSave));
        this.$parent.$refs.menuNav.goPath(0, "/home");
      } else {
        const onceNews = {
          ruleForm: { send, collect },
          typeContent: util.stringthingType(data.item_type),
          textarea: data.item_note,
          daofu_amount: data.daofu_amount,
          service_type: data.service_type,
          express_type: data.express_type,
          pri:data.pri,
          morder_marking_infos:data.morder_marking_infos,
          onceNews:true,
        };
        myLocalStorage.setItem("onceNews", JSON.stringify(onceNews));
        this.$parent.$refs.menuNav.goPath(1, "/customer");
      }
    },
    //面单不足提醒
    async faceLesswarn(next){
      let result = await print.ywyauthorize()
      if(!result.success){
        const data = result.data;
        if(data.code == 9003){ //面单授权未开启
          if([1,2].includes(data.data.team_role)){  //团长或个人
            this.$toast(true,{
              title:'面单授权未开启',
              htmlstring:'<div>当前面单授权未开启，请联系合作快递员</div>'+
              '<div>“'+data.data.ywy_name+'”确定授权状态</div>'+
              '<div>快递员电话：'+data.data.ywy_phone+'</div>'
            },'ywyauthorize',()=>{
              // next()
            })
          }else{ //团员
            this.$toast(true,{
              title:'面单授权未开启',
              htmlstring:'<div>当前面单授权未开启，请尽快联系团长</div>'+
              '<div>向合作快递员确定授权状态</div>'
            },'ywyauthorize',()=>{
              // next()
            })
          }
        }else if(data.code == 9004){ //面单余额不足
          if([1,2].includes(data.data.team_role)){  //团长或个人
            this.$toast(true,{
              title:'面单余量过低提醒',
              htmlstring:'<div>当前剩余单量'+data.data.left_value+'单，请联系合作快递员</div>'+
              '<div>“'+data.data.ywy_name+'”充值面单</div>'+
              '<div>快递员电话：'+data.data.ywy_phone+'</div>'
            },'ywyauthorize',()=>{
              next()
            })
          }else{ //团员
            this.$toast(true,{
              title:'面单余量过低提醒',
              htmlstring:'<div>当前剩余单量'+data.data.left_value+'单，请尽快联系团长</div>'+
              '<div>充值面单</div>'
            },'ywyauthorize',()=>{
              next()
            })
          }
        }else{
          this.$message.error('查询面单余量失败code-'+ data.code)
        }
      }else{
        next()
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.pend {
  padding-bottom: 40px;
  .selectBox{
    width: 130px
  }
  .search {
    padding: 10px 40px 0 20px;
    background: #fff;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .input-with-select {
      width: 340px;

      /deep/ .el-select .el-input {
        width: 150px;
        color: #606266;
      }

      /deep/ .el-input-group__prepend {
        background-color: #fff;
      }

      /deep/ .el-input__inner {
        color: #606266;
        padding-right: 16px;
      }
    }

    .info-select {
      width: 280px;
      margin-left: 40px;
    }
/deep/ .el-form-item {
      margin-bottom:11px;
      margin-right: 40px;
    }
    .operation {
      margin-left: auto;
    }
  }

  .table {
    background: #ffffff;
    padding:0px 20px 4px;

    .topHeader {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 36px;
      font-size:14px;
      margin-bottom:6px;

      >div {
        color: #666666;
        .total {
          color: #409EFF;
          padding:0 6px;
        }
      }

      .sortMethod {
        margin-right: 20px;
        font-size: 14px;
      }

      .export {
        margin-left: 50px;
        .exportBtn{
          color: #409EFF;
          background: #ecf5ff;
          border-color: #b3d8ff;
          padding: 9px 15px;
          font-size: 12px;
          border-radius: 3px;
          border: 1px solid #DCDFE6;
          box-sizing:border-box;
          margin-left: 20px
        }
      }
    }

    label {
      color: #666666;

      .total {
        color: #409EFF;
      }
    }
    .headurl{
      width: 24px;
      height: 24px;
      border-radius: 50%;
      vertical-align: text-bottom;
    }
  }

  .pages {
    background: #ffffff;
    display: flex;
    justify-content: space-between;
    padding-right: 40px;

    .pages_right {
      display: flex;

      .sure {
        display: inline-block;
        width: 48px;
        height: 28px;
        margin: 0 5px;
        font-size: 12px;
        text-align: center;
        line-height: 28px;
        border-radius: 4px;
        border: 1px solid rgba(220, 220, 220, 1);
        cursor: pointer;
      }

      .sure:hover {
        background: #2288f8;
        border: 1px solid #2288f8;
        color: #fff;
      }
    }
  }

  footer {
    height: 40px;
    position: fixed;
    z-index: 99;
    left: 0;
    bottom: 0;
    right: 0;

    .footer {
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
      padding-left: 60px;

      >div {
        width: 1200px;
        margin: 0 auto;
        text-align: center;

        .allCheck {
          float: left;
          span{
            padding-left:10px
            b{
              padding:0 5px;
              color:red
            }
          }
        }
      }

      .btn {
        justify-content: center;
        align-items: center;
        .footBtn{
          margin-right 50px
          padding 8px 20px
        }
      }
    }
  }

  .piint_title, .print_content {
    text-align: center;
  }

  .print_content {
    margin-top: 20px;

    .qrcode {
      width: 180px;
      height: 180px;
      margin: 0 auto;
      padding-bottom: 15px;
    }
  }

  /deep/.el-dialog--center .el-dialog__body {
    padding-bottom: 10px;
  }
}

/deep/.el-autocomplete-suggestion__list{
}
.operation_div {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;

  div {
    cursor: pointer;
    color: #2288F8;

    &:active {
      transform: scale(0.95);
      background: #fff;
    }
    &:hover{
      background: #fff;
    }
  }
}
.print {
  margin-top: 10px;
  display: flex;

  a {
    padding: 4px 20px;
    border-radius: 4px;
    color: #1C8BF6;
    border: 1px solid #1C8BF6;
  }

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.9;
  }
}
.info {
  padding:6px 0px 6px 50px;
  width: 1000px;
  box-size:boder-box;
  .info_left {
    flex: 1;
    display: flex;
    align-items: center;
    text-align: left;

    .el-row {
      margin-bottom: 10px;
    }

    >div {
      padding-left: 40px;
      width: 80%;

      .grid-flex {
        display: flex;

        & span:nth-child(1) {
          flex-basis: 15%;
        }

        & span:nth-child(2) {
          flex-basis: 85%;
        }
      }

      .grid-flex2 {
        display: flex;

        & span:nth-child(1) {
          flex-basis: 8%;
        }

        & span:nth-child(2) {
          flex-basis: 92%;
        }
      }

      span {
        color: #000;
      }
    }
  }

  .info_right {
    flex-basis: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #2288F8;

    >div {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:active {
        transform: scale(0.95);
      }

      img {
        width: 12px;
        height: 6px;
        margin-left: 8px;
      }
    }
  }
}
.copyCope{
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
}
.lookImg{
  width: 14px;
  height: 10px;
  display: inline-block;
  cursor: pointer;
}
.sb_pointer{
  cursor: pointer;
}

.courier{
  text-align:left
}
</style>
<style lang="stylus">
.my-autocomplete{
  .el-autocomplete-suggestion__list::before{
    content:'搜索历史';
    padding-left:20px;
  }
}
.el-table .cell{
  line-height: 16px;
}
#tableBox{
    .el-table__body-wrapper::-webkit-scrollbar {
      width: 10px;
      height:10px;
    }
    .el-table__body-wrapper::-webkit-scrollbar-thumb {
      border-radius: 6px;
      height: 50px;
      background: rgba(0, 0, 0, 0.2);//滚动条颜色
    }
    .el-table__body-wrapper::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      background: #eee;//滚动条背景色
    } 
}
.el-table__fixed-body-wrapper .info{
  visibility: hidden;
}
.paddL10{
  padding-left:10px;
}
</style>
